"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    handleSearch = _ref.handleSearch;
  return {
    FILTER_ITEMS: [{
      type: 'input',
      label: '券包名称',
      field: 'packageName',
      value: '',
      placeholder: '请输入券包名称',
      width: '240px',
      attrs: {
        clearable: true,
        prefix: 'el-icon-collection-tag'
      }
    }, {
      type: 'input',
      label: '描述关键词',
      field: 'description',
      value: '',
      placeholder: '请输入描述关键词',
      width: '240px',
      attrs: {
        clearable: true,
        prefix: 'el-icon-document'
      }
    }, {
      type: 'daterange',
      label: '创建时间',
      field: 'dateRange',
      value: '',
      placeholder: '请选择创建时间范围',
      width: '400px',
      attrs: {
        'start-placeholder': '开始日期',
        'end-placeholder': '结束日期',
        'value-format': 'yyyy-MM-dd',
        'range-separator': '至',
        'unlink-panels': true,
        'default-value': [new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()]
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setMonth(start.getMonth() - 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setMonth(start.getMonth() - 3);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }]
  };
}